import { jsx } from "react/jsx-runtime";
import { forwardRef, useCallback } from "react";
import PropTypes from "prop-types";
import { join } from "lodash/fp";
const propTypes = {
  accept: PropTypes.arrayOf(PropTypes.string),
  multiple: PropTypes.bool,
  onChange: PropTypes.func.isRequired
};
const defaultProps = {
  accept: void 0,
  multiple: false
};
const FileInput = forwardRef(({ accept, multiple, onChange }, ref) => {
  const handleChange = useCallback(
    async (event) => {
      const { files } = event.target;
      const results = await Promise.all(
        Array.from(files).map(
          (file) => new Promise((resolve) => {
            const reader = new FileReader();
            reader.readAsDataURL(file);
            reader.onload = () => {
              resolve(reader.result);
            };
          })
        )
      );
      onChange(multiple ? results : results[0]);
    },
    [multiple, onChange]
  );
  return /* @__PURE__ */ jsx(
    "input",
    {
      accept: join(", ", accept),
      type: "file",
      multiple,
      onChange: handleChange,
      ref
    }
  );
});
FileInput.propTypes = propTypes;
FileInput.defaultProps = defaultProps;
export {
  FileInput
};
